/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCopyGroupRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {CopyGroupResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const getCopyGroup = (request: GetCopyGroupRequest, options?: CashRequestOptions) => post<GetCopyGroupRequest, CopyGroupResponse>("/2.0/cash/get-copy-group", request, {...options, rejectOnError: true })